import React from 'react';
import { Balance } from 'components/profile';

const BalanceColumn = ({ styles, contract }) => (
  <div className={styles.column}>
    <div className={`${styles.inner} ${styles.info}`}>
      <Balance contract={contract} />
    </div>
  </div>
);

export default BalanceColumn;
